'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _pascalize = require('../utils/pascalize');

var _pascalize2 = _interopRequireDefault(_pascalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack'
  // 'align-self' is handled by 'align-self' plugin.


  // Support old flex spec from 2012.
};exports['default'] = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return _prefix2['default'].js + (0, _pascalize2['default'])(newProp) in style ? _prefix2['default'].css + newProp : false;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/plugins/flex-2012.js
// module id = 13
// module chunks = 0